// 导出配置的路由器
export default [
  {
    path: '/home',
    component: () => import('@/layout/index'),
    redirect: 'home',
    hidden: true,
    children: [
      {
        path: 'home',
        component: () => import('@/module/home/page/home.vue'),
        meta: {title: '测试页面'}
      }
    ]
  },
  {
    path: '/home-page',
    hidden: true,
    component: () => import('@/module/home/page/index.vue')
  }
]



// WEBPACK FOOTER //
// ./src/module/home/router/index.js